import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

export default function MoveEntityTable(props) {

  var {
    title,
    columns,
    rows,
    selectable,
    selectedIds,
    onSelectionChange,
    onAdd,
    onRowClick
  } = props;

  function isSelected(id) {
    if (!selectedIds) {
      return false;
    }
    return selectedIds.indexOf(id) !== -1;
  }

  function toggleSelection(id) {
    if (!onSelectionChange) {
      return;
    }

    var next = [];

    if (isSelected(id)) {
      next = selectedIds.filter(function (x) {
        return x !== id;
      });
    } else {
      next = selectedIds.concat(id);
    }

    onSelectionChange(next);
  }

  function handleRowClick(row) {
    if (selectable) {
      toggleSelection(row.id);
      return;
    }

    if (onRowClick) {
      onRowClick(row);
    }
  }

  /* ================= STATUS PILL ================= */

  function renderStatusPill(value) {

    var baseStyle = {
      display: "flex",
      padding: "4px 10px",
      borderRadius: "12px",
      fontSize: "12px",
      fontWeight: 600,
      whiteSpace: "nowrap",
	  width:'90px',
	  alignItems:'center',
	  justifyContent:'space-around'
    };

    if (value === "Assigned" || value === "Allocated") {
      return (
        <span
          style={{
            ...baseStyle,
            background: "#1f7a3a",
            color: "#ffffff"
          }}
        >
          {value}
        </span>
      );
    }

    if (value === "Pending") {
      return (
        <span
          style={{
            ...baseStyle,
            background: "#fff3cd",
            color: "#856404"
          }}
        >
          {value}
        </span>
      );
    }

    if (value === "Unallocated") {
      return (
        <span
          style={{
            ...baseStyle,
            background: "#eeeeee",
            color: "#424242"
          }}
        >
          {value}
        </span>
      );
    }

    return (
      <span
        style={{
          ...baseStyle,
          background: "#e0e0e0",
          color: "#333"
        }}
      >
        {value || "Unknown"}
      </span>
    );
  }

  /* ================= RENDER ================= */

  return (
    <div style={styles.container}>

      {/* HEADER */}
      {(title || onAdd) && (
        <div style={styles.header}>
          <div style={styles.title}>{title}</div>

          {onAdd && (
            <div style={styles.add} onClick={onAdd}>
              <FontAwesomeIcon icon={faPlus} />
              <span style={{ marginLeft: "6px" }}>Add</span>
            </div>
          )}
        </div>
      )}

      {/* TABLE */}
      <table style={styles.table}>
        <thead>
          <tr>
            {selectable && <th style={styles.thCheckbox} />}

            {columns.map(function (col) {
              return (
                <th key={col.key} style={styles.th}>
                  {col.label}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {rows.map(function (row) {
            return (
              <tr
                key={row.id}
                style={styles.tr}
                onClick={function () {
                  handleRowClick(row);
                }}
              >
                {selectable && (
                  <td style={styles.tdCheckbox}>
                    <input
                      type="checkbox"
                      checked={isSelected(row.id)}
                      onChange={function () {
                        toggleSelection(row.id);
                      }}
                      onClick={function (e) {
                        e.stopPropagation();
                      }}
                    />
                  </td>
                )}

                {columns.map(function (col) {
                  return (
                    <td key={col.key} style={styles.td}>
                      {col.type === "status"
                        ? renderStatusPill(row[col.key])
                        : row[col.key] || "-"}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>

    </div>
  );
}

/* ================= STYLES ================= */

const styles = {

  container: {
    width: "100%"
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px"
  },

  title: {
    fontSize: "15px",
    fontWeight: 600
  },

  add: {
    cursor: "pointer",
    color: "#2F80ED",
    fontSize: "13px",
    fontWeight: 600
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "13px",
    background: "#fff"
  },

  th: {
    textAlign: "left",
    padding: "10px",
    borderBottom: "2px solid #e6e6e6",
    whiteSpace: "nowrap",
	background: "linear-gradient(180deg, #FFFFFF 0%, #E7E9EC 100%)",
  },

  thCheckbox: {
    width: "36px",
    borderBottom: "2px solid #e6e6e6",
	background: "linear-gradient(180deg, #FFFFFF 0%, #E7E9EC 100%)",
  },

  tr: {
    borderBottom: "1px solid #eee",
    cursor: "pointer"
  },

  td: {
    padding: "10px",
    verticalAlign: "middle"
  },

  tdCheckbox: {
    textAlign: "center"
  }
};
